import { getObjectKeysAsObject } from "@checkout/helpers";
import { ParentState } from "@checkout/types";
import type { PartialParentContextWithHtsLodgingCfar } from "./types";

export const guards = {
  hasHtsCfarIdAndEnabled: (
    ctx: PartialParentContextWithHtsLodgingCfar,
    _event: unknown
  ) => ctx[ParentState.htsLodgingCfar].selectedOffer != null,
};

export const GuardTypes = getObjectKeysAsObject(guards);
